import { FC, Suspense } from 'react';
import { Hero, Promo, Feedback, Blog } from './components';
import { DiscountedAsync } from './components/Discounted';
import { DiscountedSkeleton } from './components/Discounted/DiscountedSkeleton';
import { FeaturedAsync } from './components/Featured';
import { FeaturedCarouselSkeleton } from './components/Featured/FeaturedCarouselSkeleton';
import { IndividualProjectAsync } from './components/IndividualProject';
import { IndividualProjectSkeleton } from './components/IndividualProject/IndividualProjectSkeleton';
import { SellProperty } from '@/features/components';
import { ProdGate } from '@/components';
import { type Locale } from '@/config/i18n/locales';

type HomeScreenProps = {
  locale: Locale;
  pageId: string;
};

export const HomeScreen: FC<HomeScreenProps> = ({ locale, pageId }) => {
  return (
    <>
      <Hero />
      <SellProperty />
      <Suspense fallback={<FeaturedCarouselSkeleton />}>
        <FeaturedAsync locale={locale} pageId={pageId} />
      </Suspense>
      <ProdGate>
        <Promo />
        <Suspense fallback={<DiscountedSkeleton />}>
          <DiscountedAsync locale={locale} pageId={pageId} />
        </Suspense>
        <Blog />
        <Feedback />
      </ProdGate>
      <Suspense fallback={<IndividualProjectSkeleton />}>
        <IndividualProjectAsync locale={locale} pageId={pageId} />
      </Suspense>
    </>
  );
};
